import type {
	BlogInteractionsData,
	Comment,
	CreateCommentInput,
	NodeBlock,
	Note,
} from "@adafia/types";
import { API_V1 } from "./blogs-config";

export const getPublishedNotes = async (): Promise<Note[]> => {
	const res = await fetch(API_V1, { credentials: "include" });
	if (!res.ok) throw new Error("Failed to fetch blog posts");
	return res.json();
};

export const getPublishedNote = async (id: string): Promise<Note> => {
	const res = await fetch(`${API_V1}/${id}`, { credentials: "include" });
	if (!res.ok) throw new Error("Failed to fetch blog post");
	return res.json();
};

// --- Interactions ---

export const getInteractions = async (
	id: string,
): Promise<BlogInteractionsData> => {
	const res = await fetch(`${API_V1}/${id}/interactions`, {
		credentials: "include",
	});
	if (!res.ok) throw new Error("Failed to fetch interactions");
	return res.json();
};

export const incrementView = async (id: string): Promise<void> => {
	await fetch(`${API_V1}/${id}/view`, {
		method: "POST",
		credentials: "include",
	});
};

export const incrementLike = async (id: string): Promise<void> => {
	await fetch(`${API_V1}/${id}/like`, {
		method: "POST",
		credentials: "include",
	});
};

export const incrementBlockLike = async (
	id: string,
	blockId: string,
): Promise<void> => {
	await fetch(`${API_V1}/${id}/blocks/${blockId}/like`, {
		method: "POST",
		credentials: "include",
	});
};

export const getNodeBlocks = async (id: string): Promise<NodeBlock[]> => {
	const res = await fetch(`${API_V1}/${id}/blocks`, { credentials: "include" });
	if (!res.ok) throw new Error("Failed to fetch node blocks");
	return res.json();
};

// --- Comments ---

export const getComments = async (id: string): Promise<Comment[]> => {
	const res = await fetch(`${API_V1}/${id}/comments`, {
		credentials: "include",
	});
	if (!res.ok) throw new Error("Failed to fetch comments");
	return res.json();
};

export const addComment = async (
	id: string,
	input: Omit<CreateCommentInput, "nodeId">,
): Promise<Comment> => {
	const res = await fetch(`${API_V1}/${id}/comments`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(input),
		credentials: "include",
	});
	if (!res.ok) throw new Error("Failed to add comment");
	return res.json();
};

export const deleteComment = async (
	id: string,
	commentId: string,
): Promise<void> => {
	const res = await fetch(`${API_V1}/${id}/comments/${commentId}`, {
		method: "DELETE",
		credentials: "include",
	});
	if (!res.ok) throw new Error("Failed to delete comment");
};
